import { gql } from '@apollo/client';

export default gql`
  query accountAddresses {
    accountAddresses {
      id
      address
      address2
      city
      region
      postalCode
      country
      isBilling
      isShipping
      isDefault
      accountId
      createdAt
    }
  }
`;
